// Teaser vor dem Verkaufsstart (Passwortseite).
// Rechts zeigen die Streifen beim Darüberfahren ihr Motiv; ein Klick merkt das Produkt vor.
// Die Warteliste ist das Shopify-Kundenformular. contact[tags] speichert:
//   early-access, warteliste, teaser   jede Anmeldung hier
//   interesse-<handle>                 per Klick/Tippen bewusst vorgemerktes Produkt
//   gezeigt-<handle>                   ohne Auswahl: das Motiv, das beim Eintragen zu sehen war
//   quelle-<…>, kampagne-<…>           Herkunft aus utm_source/utm_campaign oder Klick-IDs der Werbenetzwerke
// Nach dem Eintragen öffnet ein Hinweisfenster („E-Mail bestätigen“). Kommt jemand über den Knopf der
// Bestätigungs-Mail zurück (#bestaetigt, früher Merker „alure-bestaetigung“), zeigt die Seite „Du bist dabei.“
(() => {
  const root = document.querySelector(".teaser");
  if (!root) return;
  const texts = root.querySelector(".teaser-dock")?.dataset || {};

  const reduceMotion = () => matchMedia("(prefers-reduced-motion: reduce)").matches;
  const session = {
    get(key) { try { return JSON.parse(sessionStorage.getItem(`alure-teaser-${key}`)); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(`alure-teaser-${key}`, JSON.stringify(value)); } catch { /* ohne Speicher */ } },
  };

  // ------------------------------------------------------------------
  // Herkunft der Besucher (erste Landung in dieser Sitzung)
  // ------------------------------------------------------------------
  const slug = (text) => String(text || "").toLowerCase().normalize("NFKD").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40);
  (() => {
    if (session.get("source")) return;
    const params = new URLSearchParams(location.search);
    let source = slug(params.get("utm_source"));
    if (!source && params.has("ttclid")) source = "tiktok";
    if (!source && params.has("fbclid")) source = "meta";
    if (!source && params.has("gclid")) source = "google";
    // Shopify leitet „/“ ohne Parameter auf /password um. Dann bleibt nur die verweisende Seite.
    if (!source && document.referrer) {
      let host = "";
      try { host = new URL(document.referrer).hostname.replace(/^www\./, ""); } catch { /* ungültig */ }
      if (/tiktok/.test(host)) source = "tiktok";
      else if (/instagram|facebook|fb\.com|threads/.test(host)) source = "meta";
      else if (/pinterest/.test(host)) source = "pinterest";
      else if (/^google\.|\.google\./.test(host)) source = "google";
      else if (host && host !== location.hostname && !/shopify/.test(host)) source = slug(host);
    }
    const campaign = slug(params.get("utm_campaign"));
    if (source || campaign) session.set("source", { source, campaign });
  })();

  // ------------------------------------------------------------------
  // Motive und Auswahl
  // ------------------------------------------------------------------
  const SLIDE_MS = 6000;
  const slides = [...root.querySelectorAll("[data-slide]")];
  const picks = [...root.querySelectorAll("[data-pick]")];
  const group = root.querySelector(".teaser-picks");
  const toggle = root.querySelector("[data-slides-toggle]");
  const toggleLabel = root.querySelector("[data-slides-label]");
  const targets = {
    no: [...root.querySelectorAll("[data-teaser-no]")],
    name: [...root.querySelectorAll("[data-teaser-name]")],
    price: [...root.querySelectorAll("[data-teaser-price]")],
  };
  const slideFor = (pick) => slides.find((s) => s.dataset.slide === pick?.dataset.pick);

  function hydrate(img) {
    if (!img || !img.dataset.src) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
    delete img.dataset.srcset;
  }

  function swapText(el, text) {
    if (!el || el.textContent === text) return;
    if (reduceMotion()) { el.textContent = text; return; }
    el.classList.add("is-swapping");
    setTimeout(() => {
      el.textContent = text;
      el.classList.remove("is-swapping");
    }, 200);
  }

  let current = Math.max(0, picks.findIndex((p) => p.classList.contains("is-active")));
  let pinned = null;
  let chosen = false; // nur echte Auswahl (Klick, Tippen, Enter) zählt als Interesse
  let token = 0;

  function show(pos) {
    if (!picks.length) return;
    current = (pos + picks.length) % picks.length;
    const pick = picks[current];
    picks.forEach((p) => p.classList.toggle("is-active", p === pick));
    targets.no.forEach((el) => { el.textContent = pick.dataset.no; });
    targets.name.forEach((el) => swapText(el, pick.dataset.name));
    targets.price.forEach((el) => { el.textContent = pick.dataset.price; });

    const slide = slideFor(pick);
    hydrate(slide);
    hydrate(slideFor(picks[(current + 1) % picks.length]));
    const mine = ++token;
    const activate = () => {
      if (mine !== token) return;
      slides.forEach((s) => {
        const on = s === slide;
        s.classList.toggle("is-active", on);
        if (on) s.removeAttribute("aria-hidden"); else s.setAttribute("aria-hidden", "true");
      });
    };
    if (!slide || slide.complete) activate();
    else {
      slide.addEventListener("load", activate, { once: true });
      slide.addEventListener("error", activate, { once: true });
    }
  }

  function pin(pos) {
    pinned = pos;
    picks.forEach((p, i) => p.setAttribute("aria-pressed", String(i === pos)));
    session.set("pick", picks[pos]?.dataset.handle || null);
    stop();
  }

  // Diashow mit Pause-Knopf; steht still, sobald etwas vorgemerkt ist.
  let timer = 0;
  let pausedByUser = false;
  let hovering = false;

  function restartBar() {
    if (!toggle) return;
    toggle.classList.remove("is-ticking");
    if (!timer) return;
    void toggle.offsetWidth;
    toggle.classList.add("is-ticking");
  }
  function stop() {
    clearInterval(timer);
    timer = 0;
    restartBar();
  }
  function start() {
    stop();
    if (pinned !== null || pausedByUser || hovering || document.hidden || reduceMotion() || picks.length < 2) return;
    timer = setInterval(() => {
      show(current + 1);
      restartBar();
    }, SLIDE_MS);
    restartBar();
  }

  picks.forEach((pick, pos) => {
    pick.addEventListener("pointerenter", (event) => {
      if (event.pointerType !== "mouse") return;
      hovering = true;
      stop();
      show(pos);
    });
    pick.addEventListener("pointerleave", (event) => {
      if (event.pointerType !== "mouse") return;
      hovering = false;
      if (pinned !== null) show(pinned); else start();
    });
    pick.addEventListener("focus", () => { if (!pick.matches(":hover")) { stop(); show(pos); } });
    pick.addEventListener("blur", () => { if (pinned !== null) show(pinned); else start(); });
    pick.addEventListener("click", () => {
      chosen = true;
      pin(pos);
      show(pos);
    });
  });
  // Mit Maus: alle Motive laden, damit der Wechsel beim Darüberfahren sofort sitzt.
  group?.addEventListener("pointerenter", (event) => {
    if (event.pointerType === "mouse") slides.forEach(hydrate);
  }, { once: true });

  if (toggle && picks.length > 1 && !reduceMotion()) {
    document.documentElement.style.setProperty("--slide-ms", `${SLIDE_MS}ms`);
    toggle.hidden = false;
    toggle.addEventListener("click", () => {
      pausedByUser = !pausedByUser;
      toggle.setAttribute("aria-pressed", String(pausedByUser));
      if (toggleLabel) toggleLabel.textContent = pausedByUser ? (texts.labelPlay || "Abspielen") : (texts.labelPause || "Pause");
      if (pausedByUser) stop(); else start();
    });
  }
  document.addEventListener("visibilitychange", () => (document.hidden ? stop() : start()));

  // Das nächste Motiv vorladen, sobald der Browser Zeit hat.
  addEventListener("load", () => {
    const next = () => hydrate(slideFor(picks[(current + 1) % picks.length]));
    if ("requestIdleCallback" in window) requestIdleCallback(next); else setTimeout(next, 1200);
  });

  // ------------------------------------------------------------------
  // Warteliste
  // ------------------------------------------------------------------
  const form = root.querySelector("form.teaser-form");
  const email = root.querySelector("[data-teaser-email]");
  const error = root.querySelector("[data-teaser-error]");
  const tags = root.querySelector("[data-teaser-tags]");
  const submit = root.querySelector("[data-teaser-submit]");
  const done = root.querySelector("[data-teaser-done]");
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setError(message) {
    if (!error || !email) return;
    error.textContent = message;
    error.hidden = !message;
    if (message) email.setAttribute("aria-invalid", "true"); else email.removeAttribute("aria-invalid");
  }

  // Beim Tippen bleibt das gezeigte Motiv stehen (ohne „Vorgemerkt“, das gibt es nur nach echter Auswahl).
  email?.addEventListener("focus", () => {
    if (pinned !== null) return;
    pinned = current;
    stop();
  });
  email?.addEventListener("input", () => { if (email.getAttribute("aria-invalid") === "true" && EMAIL.test(email.value.trim())) setError(""); });

  form?.addEventListener("submit", (event) => {
    if (!email) return;
    const value = email.value.trim();
    if (!EMAIL.test(value)) {
      event.preventDefault();
      setError(texts.msgEmail || "Bitte gib eine gültige E-Mail-Adresse ein, z. B. name@beispiel.de.");
      email.focus();
      return;
    }
    email.value = value;
    session.set("email", value);
    const pick = picks[pinned ?? current];
    const list = (tags?.value || "early-access, warteliste, teaser").split(",").map((t) => t.trim()).filter(Boolean);
    if (pick?.dataset.handle) list.push(`${chosen ? "interesse" : "gezeigt"}-${pick.dataset.handle}`);
    const origin = session.get("source");
    if (origin?.source) list.push(`quelle-${origin.source}`);
    if (origin?.campaign) list.push(`kampagne-${origin.campaign}`);
    if (tags) tags.value = [...new Set(list)].join(", ");
    session.set("label", chosen && pick ? `${pick.dataset.no} – ${pick.dataset.name}` : null);
    try {
      window.Shopify?.analytics?.publish?.("alure_warteliste", { product: pick?.dataset.handle || "", source: origin?.source || "" });
    } catch { /* Messung ist optional */ }
    submit?.setAttribute("aria-busy", "true");
  });

  // Nach dem Absenden lädt Shopify die Seite neu: Auswahl wiederherstellen, Ergebnis zeigen.
  const posted = Boolean(done) || (error && !error.hidden);
  if (posted) {
    const handle = session.get("pick");
    const pos = picks.findIndex((p) => p.dataset.handle === handle);
    if (pos >= 0) { pin(pos); show(pos); }
  }
  if (done) {
    const label = session.get("label");
    const line = root.querySelector("[data-teaser-done-pick]");
    if (label && line) {
      line.textContent = `${texts.labelSaved || "Vorgemerkt"}: ${label}`;
      line.hidden = false;
    }
  } else if (error && !error.hidden) {
    email?.focus({ preventScroll: true });
  }

  // Sprung zur Warteliste (Handy)
  root.querySelector(".teaser-jump")?.addEventListener("click", (event) => {
    const target = document.getElementById("warteliste");
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion() ? "instant" : "smooth", block: "center" });
    email?.focus({ preventScroll: true });
  });

  // ------------------------------------------------------------------
  // Fenster: Impressum, Datenschutz, Shop-Zugang
  // ------------------------------------------------------------------
  const sheets = [...document.querySelectorAll(".teaser-sheet")];
  let opener = null;
  function openSheet(id) {
    const sheet = document.getElementById(id);
    if (!sheet || sheet.open || typeof sheet.showModal !== "function") return false;
    opener = document.activeElement;
    sheets.forEach((s) => s.open && s.close());
    sheet.showModal();
    document.documentElement.classList.add("ea-lock");
    return true;
  }
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-teaser-open]");
    if (trigger && openSheet(trigger.dataset.teaserOpen)) event.preventDefault();
  });
  sheets.forEach((sheet) => {
    sheet.addEventListener("click", (event) => {
      if (event.target === sheet || event.target.closest("[data-teaser-close]")) sheet.close();
    });
    sheet.addEventListener("close", () => {
      document.documentElement.classList.remove("ea-lock");
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
      opener = null;
    });
  });
  // Direkt verlinkbar: /password#impressum, #datenschutz
  const fromHash = location.hash.slice(1);
  if (["impressum", "datenschutz"].includes(fromHash)) openSheet(fromHash);
  if (document.querySelector("[data-teaser-pass-error]")) openSheet("shop-zugang");

  // ------------------------------------------------------------------
  // Eingetragen: Hinweis aufs Postfach, mit der eingegebenen Adresse
  // ------------------------------------------------------------------
  const savedEmail = session.get("email");
  if (savedEmail) document.querySelectorAll("[data-teaser-email-out]").forEach((el) => { el.textContent = savedEmail; });
  if (done) openSheet("warteliste-pruefen");

  // ------------------------------------------------------------------
  // Bestätigt: zurück von Shopifys Bestätigungslink (höchstens 10 Minuten alt)
  // ------------------------------------------------------------------
  let confirmedAt = 0;
  try {
    confirmedAt = Number(sessionStorage.getItem("alure-bestaetigung")) || 0;
    sessionStorage.removeItem("alure-bestaetigung");
  } catch { /* ohne Speicher keine Rückmeldung */ }
  // Neuer Weg: Mail-Knopf = Shopify-Link + #bestaetigt; der Browser behält die Markierung über die Weiterleitung.
  if (location.hash === "#bestaetigt") {
    confirmedAt = Date.now();
    try { history.replaceState(null, "", location.pathname + location.search); } catch { /* egal */ }
  }
  if (confirmedAt && Date.now() - confirmedAt < 10 * 60 * 1000) {
    const confirmedCard = root.querySelector("[data-teaser-confirmed]");
    if (form && confirmedCard) {
      form.hidden = true;
      confirmedCard.hidden = false;
    }
    try { localStorage.setItem("alure-warteliste", "bestaetigt"); } catch { /* egal */ }
    openSheet("warteliste-bestaetigt");
  }

  start();
})();
